import { ReadOnlyField } from "@shared-kernel/primary/shared/shadcn/ui/read-only-field";
import { formatSiret } from "@utils/formatting";
import { ORGANIZATION_INFO, type ORGANIZATION } from "@shared-kernel/domain/organization";

interface Props {
  organization: ORGANIZATION;
}

export const BillingAddressField = ({ organization }: Props) => {
  const address = ORGANIZATION_INFO[organization];

  return (
    <ReadOnlyField label="Facturer à">
      <p className="font-medium">{address.name}</p>
      <p className="text-muted-foreground">{address.address}</p>
      <p className="text-muted-foreground">
        {address.postalCode} {address.city}
      </p>
      <p className="text-muted-foreground">SIRET : {formatSiret(address.siret)}</p>
    </ReadOnlyField>
  );
};
